import React from 'react';
import './FormActions.css';

const noop = () => {};

const FormActions = ({
  submitLabel = 'Save Changes',
  cancelLabel = 'Cancel',
  isSaving = false,
  onCancel = noop,
  sticky = false,
  variant = 'default',
  children
}) => {
  const classes = ['admin-form-actions'];
  if (sticky) {
    classes.push('admin-form-actions--sticky');
  }
  if (variant === 'footer') {
    classes.push('admin-form-actions--footer');
  }

  return (
    <div className={classes.join(' ')}>
      {children}
      <div className="admin-form-actions-buttons">
        <button type="button" className="admin-secondary-btn" onClick={onCancel} disabled={isSaving}>
          {cancelLabel}
        </button>
        <button type="submit" className="admin-primary-btn" disabled={isSaving}>
          {isSaving ? 'Saving...' : submitLabel}
        </button>
      </div>
    </div>
  );
};

export default FormActions;
